// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"container___s2PuK","url":"url___owYDV"};